module.exports = __webpack_public_path__ + "img/landing-bg-fe26.3e0336fc.jpg";